import React from 'react';
import { motion } from 'framer-motion';
import { DONATE_URL } from '../utils/donate';
export function FinalCTA() {
  return <section className="relative py-24 bg-pac-navy overflow-hidden border-t-4 border-pac-red" data-id="element-75" data-mp="3udp0mtecbqr2">
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-76" data-mp="c7k61z6m2ppe" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-77" data-mp="m3dscaa4txkd">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-78" data-mp="h52i3yfxdl1m">
          <p className="text-pac-gold font-bold uppercase tracking-[0.2em] text-sm mb-5" data-id="element-79" data-mp="qw6vwutv6zuv">
            Built Locally. Stronger Together.
          </p>
          <h2 className="font-serif text-4xl md:text-6xl font-bold text-white mb-6 drop-shadow-md" data-id="element-80" data-mp="zwmvvubefouz">
            Help Defend the Voice{' '}
            <span className="text-pac-gold" data-id="element-81" data-mp="2c5ya3o20ajdw">Closest to Home.</span>
          </h2>
          <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto font-light" data-id="element-82" data-mp="2h2y779gvobsv">
            Stand with leaders who trust Arizonans to shape safe, thriving
            communities that the next generation will be proud to call home.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-83" data-mp="2qzugviiij3z0">
            <a href={DONATE_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-pac-red hover:bg-red-800 text-white px-10 py-5 rounded font-bold text-xl uppercase tracking-wider transition-all shadow-[0_0_20px_rgba(185,28,28,0.4)] hover:shadow-[0_0_30px_rgba(185,28,28,0.7)] transform hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-pac-gold focus:ring-offset-2 focus:ring-offset-pac-navy" data-id="element-84" data-mp="2v38z8ftxbwfm">
              Contribute Now
            </a>
            <a href="#join" className="w-full sm:w-auto bg-transparent border-2 border-slate-500 text-slate-300 hover:border-white hover:text-white px-10 py-5 rounded font-bold text-xl uppercase tracking-wider transition-all" data-id="element-85" data-mp="1jntsjwpbo3ze">
              Join the Coalition
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}